export enum OnBoardingDialogType {
  Info = 'INFO',
  Tour = 'TOUR',
  Tip = 'TIP',
}
